import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import themeReducer from './themeSlice';
import cartReducer from './cartSlice';
import { persistenceMiddleware, rehydrateMiddleware } from './middleware/persistenceMiddleware';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        theme: themeReducer,
        cart: cartReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }).concat(persistenceMiddleware, rehydrateMiddleware),
});
